import { useState } from 'react';

import { useDebouncedCallback } from '../../../hooks';

const useTitleSearch = () => {
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState<string | undefined>();

  const debouncedOnSearchChange = useDebouncedCallback(setDebouncedSearch);

  return {
    setSearch: (input: string) => {
      setSearch(input);
      debouncedOnSearchChange(input === '' ? undefined : input);
    },
    search,
    debouncedSearch,
  };
};

export default useTitleSearch;
